import { CLABE_LENGTH, CREDIT_PLAZA } from '@config/index';
import { tscope } from '@i18n';

const ts = tscope('FormResolver');

export const isBankClabeValid = (value, options = {}) => {
  if (!value) return null;

  const banksCatalogue = options?.banksCatalogue || [];
  const error = {
    type: 'danger',
  };

  if (value.length !== CLABE_LENGTH) {
    error.message = ts('clabeLength');
    return error;
  }

  if (value.slice(3, 6).includes(CREDIT_PLAZA)) {
    error.message = ts('isCreditCard');
    return error;
  }

  if (!banksCatalogue.some((bank) => bank.abmNumber === value.slice(0, 3))) {
    error.message = ts('ABMNotFound');
    return error;
  }

  return null;
};
